export const MOVE_TO_ANOTHER_GATEWAY_REQUEST = 'MOVE_TO_ANOTHER_GATEWAY_REQUEST';
export const MOVE_TO_ANOTHER_GATEWAY = 'MOVE_TO_ANOTHER_GATEWAY';
export const VALIDATE_GATEWAY_ASSET_REQUEST = 'VALIDATE_GATEWAY_ASSET_REQUEST';
export const VALIDATE_GATEWAY_ASSET = 'VALIDATE_GATEWAY_ASSET';
export const CLEAR_VALIDATE_GATEWAY_ASSET_STATE = 'CLEAR_VALIDATE_GATEWAY_ASSET_STATE';

export const MAX_SEARCH_LENGTH = 50;
